import { generateKeyBetween } from 'fractional-indexing';

/**
 * Convenção do board (sort kanbanRank DESC): topo visual = chave MAIOR.
 * `aboveRank`/`belowRank` são os ranks dos vizinhos RANQUEADOS resolvidos
 * (null = extremidade aberta). A inversão above/below encapsula a direção
 * desc: generateKeyBetween(a, b) da lib exige a < b e retorna a < key < b.
 *
 * Lança Error quando os bounds são inválidos (ex.: ranks iguais por corrida
 * de dois usuários) — o caller trata com refetch + toast (spec SP2 §8).
 */
export function rankBetween(aboveRank: string | null, belowRank: string | null): string {
  return generateKeyBetween(belowRank, aboveRank);
}

/**
 * Resolve os bounds de rank para inserção em `insertIndex` (0 = topo),
 * PULANDO vizinhos não-ranqueados em ambas as direções (spec SP2 §5.2 —
 * evita generateKeyBetween(null, null) colidir com ranks existentes).
 * `items` = lista visual da coluna SEM o card sendo movido.
 */
export function resolveNeighborRanks(
  items: Array<{ id: string; kanbanRank?: string }>,
  insertIndex: number,
): { aboveRank: string | null; belowRank: string | null } {
  let aboveRank: string | null = null;
  for (let i = insertIndex - 1; i >= 0; i--) {
    const rank = items[i]?.kanbanRank;
    if (rank) { aboveRank = rank; break; }
  }
  let belowRank: string | null = null;
  for (let i = insertIndex; i < items.length; i++) {
    const rank = items[i]?.kanbanRank;
    if (rank) { belowRank = rank; break; }
  }
  return { aboveRank, belowRank };
}
